import { render } from "./AnmeldungView.vue?vue&type=template&id=3080f07e&scoped=true"
import script from "./AnmeldungView.vue?vue&type=script&lang=js"
export * from "./AnmeldungView.vue?vue&type=script&lang=js"

import "./AnmeldungView.vue?vue&type=style&index=0&id=3080f07e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3080f07e"]])

export default __exports__